import axios from "axios";
import React, { useEffect, useState } from "react";
import ApiResponeMessageBox from "../../../components/apimessages/ApiResponeMessageBox";
import { theadLanguage } from "../../../components/data/StaticData";
import LoadingSpinner from "../../../components/spinners/LoadingSpinner";
import { useFetch } from "../../../hooks/UseFetch";
import Table from "../../page-essential/Table";
import { langsType } from "../../../types/enums/API.types";

const TabView = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadiing, setLoading] = useState(false);
  const initialApiRes = {
    type: "",
    msg: "",
  };
  const [apiRes, setApiRes] = useState(initialApiRes);

  const { data, errMsg, loading } = useFetch("lang/findAll");
  const tbodyLang: langsType[] = data?.languages;

  const [currentItemID, setCurrentItemId] = useState("");

  const handleModal = (id: string) => {
    setCurrentItemId(id);
    setIsModalOpen(true);
  };
  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios
        .delete(`${process.env.REACT_APP_API}/lang/delete/${currentItemID}`)
        .then((res) => {
          setApiRes({
            type: "success",
            msg: res.data.message,
          });
          setTimeout(() => {
            setApiRes(initialApiRes);
          }, 2000);
        });
    } catch (error: any) {
      if (error.response.err) {
        setApiRes({
          type: "error",
          msg: error.response.data.message,
        });
        setTimeout(() => {
          setApiRes(initialApiRes);
        }, 2000);
      }
    }
    setLoading(false);
    setCurrentItemId("");
    setTimeout(() => {
      setIsModalOpen(false);
    }, 1000);
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="pr-4 my-5 relative">
      {apiRes.msg && (
        <ApiResponeMessageBox type={apiRes.type} msg={apiRes.msg} />
      )}

      <div
        id="popup-modal"
        className={`fixed top-0 right-0 left-0 bg-gray-400 bg-opacity-40 h-screen z-20 flex justify-center items-center transition-all duration-300 ${
          !isModalOpen && "transition-all duration-300 -top-[100%]"
        }`}
      >
        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <button
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
              data-modal-toggle="popup-modal"
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setIsModalOpen(false)}
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="sr-only" onClick={() => setIsModalOpen(false)}>
                Close modal
              </span>
            </button>
            <div className="p-6 text-center">
              <svg
                aria-hidden="true"
                className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to delete this item?
              </h3>
              <button
                data-modal-toggle="popup-modal"
                type="button"
                className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                onClick={() => handleDelete()}
              >
                Yes, I'm sure
              </button>
              <button
                data-modal-toggle="popup-modal"
                type="button"
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                onClick={() => setIsModalOpen(false)}
              >
                No, cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <Table thead={theadLanguage}>
        {tbodyLang?.map((item, i) => (
          <tr
            key={item.id}
            className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
          >
            <td className="py-4 px-6">{i + 1}</td>
            <th
              scope="row"
              className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {item.lang}
            </th>
            <td className="py-4 px-6">{item.lang_code}</td>
            <td className="py-4 px-6">{item.lang_type}</td>
            <td className="flex items-center py-4 px-6 space-x-3">
              <a
                href="#"
                className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
              >
                Edit
              </a>
              <a
                href="#"
                className="font-medium text-red-600 dark:text-red-500 hover:underline"
                onClick={() => handleModal(item.id)}
              >
                {loadiing ? "Loading..." : "Remove"}
              </a>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
};

export default TabView;
